import React from 'react';
import { Partner } from '../../services';
import { SelectDropdown } from '../Elements';
import usePartnerSelect from './hooks/usePartnerSelect';

interface Props {
  onChange: (e: any) => void;
  partners: Array<Partner>;
  value: string;
  notProvidedText: string;
  defaultValue?: string;
}

const PartnerSelect: React.FC<Props> = ({ onChange, partners, value, defaultValue, notProvidedText }: Props) => {
  const { items } = usePartnerSelect(partners, notProvidedText);
  return <SelectDropdown onChange={onChange} items={items} value={value} defaultValue={defaultValue} />;
};

export default PartnerSelect;
